<ng-container>

	<mat-panel-title class="title">
		{{ 'TITLE_DETAIL' | translate }}
	</mat-panel-title>

	<!-- Error panel: display the intercepted errors -->
	<form-error *ngIf="errorManager.hasError"
				[message]="errorManager.message">
	</form-error>

	<!-- Form fields section: display a list of input fields -->
	<div class="form-container">

		<div *ngFor="let field of fields"
			 class="field-container">
			<ng-container [ngSwitch]="field.type">

				<ng-container *ngSwitchCase="'DTY_LIST'">
					<span class="ellipsis"
						  matTooltip="{{field.label | translate}}"> {{ field.label | translate }}</span>
					<custom-ext-select [(defaultValue)]="detail[field.id]"
								   [disabled]="!field.editable || field.option == null || field.option.length == 0 || isFormDisabled"
								   [values]="field.option"
								   [searchable]="true"
								   [extraClass]="'filter-multi-select filter-full-width'">
					</custom-ext-select>

				</ng-container>

				<ng-container *ngSwitchCase="'DTY_DATE'">
					<span class="ellipsis"
						  matTooltip="{{field.label | translate}}"> {{ field.label | translate }}</span>
					<custom-datepicker
						[(value)]="detail[field.id]"
						[disabled]="!field.editable || isFormDisabled">
					</custom-datepicker>
				</ng-container>

				<ng-container *ngSwitchCase="'DTY_TIME'">
					<span class="ellipsis"
						  matTooltip="{{field.label | translate}}"> {{ field.label | translate }}</span>
					<custom-timepicker
						[(value)]="detail[field.id]"
						[disabled]="!field.editable || isFormDisabled">
					</custom-timepicker>
				</ng-container>

				<ng-container *ngSwitchCase="'DTY_INT'">
					<span class="ellipsis"
						  matTooltip="{{field.label | translate}}"> {{ field.label | translate }}</span>
					<custom-text-field [(value)]="detail[field.id]"
									   [appearance]="'fill'"
									   [placeholder]="field.label | translate "
									   [disabled]="!field.editable || isFormDisabled"
									   [isNumber]="true">
					</custom-text-field>
				</ng-container>


				<ng-container *ngSwitchDefault>
					<span class="ellipsis"
						  matTooltip="{{field.label | translate}}"> {{ field.label | translate }}</span>
					<custom-text-field [(value)]="detail[field.id]"
									   [appearance]="'fill'"
									   [placeholder]="field.label | translate "
									   [disabled]="isFormDisabled"
									   [isNumber]="false">
					</custom-text-field>
				</ng-container>

			</ng-container>

		</div>

	</div>

	<!-- action section: display the available action for the current role -->
	<ng-container *ngIf="hasUpdatePermission || hasInsertPermission">
		<div class="actions-container">
			<custom-btn color="primary"
						(click)="updateDetail()"
						[disabled]="isLoadingDetail || !this.hasCUPermission()">
				{{ 'LABEL_SAVE' | translate }}
			</custom-btn>

			<custom-btn color="primary"
						(click)="getDetail()"
						[disabled]="isLoadingDetail">
				{{ 'LABEL_CANCEL' | translate }}
			</custom-btn>
		</div>
	</ng-container>

</ng-container>


